import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { recordPath } from './views/item'

class ListRedirector extends Component {
  componentDidMount() {
    const { loading, recordsStale, currentRecordID } = this.props

    if (!recordsStale && !loading && !currentRecordID) {
      this.redirect()
    }
  }

  componentDidUpdate(prevProps) {
    const { loading, recordsStale, currentRecordID } = this.props

    if (prevProps.recordsStale && !recordsStale && !loading && !currentRecordID) {
      this.redirect()
    }
  }

  redirect() {
    const { records, primaryKey, history, base_url } = this.props
    const recordID = records[0] ? primaryKey(records[0]) : 'record-unavailable'
    history.push(recordPath(base_url, recordID))
  }

  render() {
    return this.props.children
  }
}

export const ListRedirect = withRouter(ListRedirector)



// WEBPACK FOOTER //
// ./src/ui/list/redirect.js